import React, { useEffect, useMemo } from 'react';
import styles from './SelectedArticlesModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useOnboardingContext } from '../../../../../contexts/OnboardingContext';
import { api } from '../../../../../services/ApiService';

interface SelectedArticlesModalProps {
    onClose: () => void;
}

const SelectedArticlesModal: React.FC<SelectedArticlesModalProps> = ({ onClose }) => {
    const { formData, setSelectedArticles } = useOnboardingContext();
    const selectedArticles = formData.selectedArticles;

    const placeholderImageUrl = useMemo(() => {
        return `${api.getBaseUrl()}storage/placeholder/tsoutfit.png`;
    }, []);

    useEffect(() => {
        if (selectedArticles.length === 0) {
            onClose();
        }
    }, [selectedArticles.length, onClose]);

    const formatPrice = (price: number): string => {
        if (price === 0) {
            return 'kostenlos';
        }
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
        }).format(price);
    };

    const handleRemove = (articleId: number) => {
        setSelectedArticles(selectedArticles.filter((article) => article.id !== articleId));
    };

    return (
        <div className={styles['selected-articles-modal']}>
            <h3 className={styles['modal-title']}>
                Ausgewählte Artikel ({selectedArticles.length})
            </h3>
            <ul className={styles['articles-list']}>
                {selectedArticles.map((article) => (
                    <li key={article.id} className={styles['article-row']}>
                        <div className={styles['article-thumb']}>
                            <img
                                src={article.imageUrl || placeholderImageUrl}
                                alt={article.name}
                            />
                        </div>
                        <div className={styles['article-info']}>
                            <span className={styles['article-name']}>{article.name}</span>
                            <span className={styles['article-price']}>
                                {formatPrice(article.price)}
                            </span>
                        </div>
                        <button
                            type="button"
                            className={styles['remove-btn']}
                            onClick={() => handleRemove(article.id)}
                            aria-label={`${article.name} entfernen`}
                            title="Entfernen"
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SelectedArticlesModal;
